import { STANDINGORDERITEM_API } from "../constants/api";
import { GetTraderParamModel } from "../model/common";
import {
  getUrl,
  optionsGet,
  getHeadersWithTokenAndTraderId,
} from "./commonService";
import customAxios from "./customAxios";

export default class StandingOrderItemService {
  getStandingOrdersItemService(params: any) {
    let api = STANDINGORDERITEM_API.LIST;
    api = api.replace("#ADDRESSID#", params.addressId);
    // console.log(api);

    const url = getUrl(api);
    const headers = getHeadersWithTokenAndTraderId(params);
    const options: any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });
  }
}
